// extracted by mini-css-extract-plugin
export default {"root":"DemoCode_root__iXN6L"};